import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { UserState } from '../../Slice/Auth/AuthSlice';
import { verifyOTP, resendOTP, userVerification } from '../../ApiCalls/Auth/login';
import { setStoredStudioAccess } from '../../../Utils/permissionUtils';
export const OTPVerificationReducer = (builder: ActionReducerMapBuilder<UserState>) => {
    builder.addCase(verifyOTP.pending, (state) => {
        state.loading = true;
        state.error = {};
        state.isError = false;
        state.apiStatus = false;
    })
        .addCase(verifyOTP.fulfilled, (state, action: PayloadAction<{
            status: number;
            success: boolean;
            data: {
                access_token: string;
                refresh_token: string;
                user_exists: boolean;
                user?: {
                    id: number;
                    name: string;
                    email: string;
                    country_code: string;
                    phone_number: string;
                    username: string;
                    role: number;
                    image: string | null;
                    is_email_verified: boolean

                }
                temp_token: string;
                studio_access?: any;
            }
        }>) => {
            state.loading = false;
            console.log(action.payload.data);
            if (action.payload.data.user_exists && action.payload.data.user) {
                const rawUser = action.payload.data.user as any;
                const normalizedImg = rawUser?.image || rawUser?.profile_image || null;
                const normalizedPhone = rawUser?.phone_number || rawUser?.phone || '';
                state.user = {
                    ...rawUser,
                    image: normalizedImg,
                    profile_image: normalizedImg,
                    phone_number: normalizedPhone,
                    phone: normalizedPhone,
                };
                state.isUserChanged = true;
                const studioAccess =
                    action.payload.data.studio_access ||
                    (action.payload as any).studio_access;
                if (studioAccess) {
                    setStoredStudioAccess(studioAccess);
                }
                const termsPayload =
                    (action.payload.data as any)?.dashboard_terms ||
                    (action.payload as any)?.dashboard_terms ||
                    rawUser?.dashboard_terms ||
                    null;
                if (termsPayload) {
                    state.dashboard_terms = termsPayload;
                }
                localStorage.setItem("access_token", action.payload.data.access_token);
                localStorage.setItem("refresh_token", action.payload.data.refresh_token);
                // console.log(action.payload.success);
                // state.apiStatus = action.payload.success;
                state.access_token = action.payload.data.access_token;
                state.isAuthenticated = true;
                state.refresh_token = action.payload.data.refresh_token;
            } else {
                console.log("called")
                // state.apiStatus = true;
                state.temporary_token = action.payload.data.temp_token;
                state.isRegister = true;
            }



        })
        .addCase(verifyOTP.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            // console.log(action.payload);
            state.error.message = action.payload.message;
            state.error.status = action.payload.status;
            state.apiStatus = false;
        }).addCase(resendOTP.pending, (state) => {
            state.loading = true;
            state.error = {};
            state.isError = false;
            state.apiStatus = false;

        }).addCase(resendOTP.fulfilled, (state, action: PayloadAction<{
            orderId: string;
        }>) => {
            state.loading = false;
        }).addCase(resendOTP.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.apiStatus = false;
            // console.log(action.payload);
            state.error = action.payload;

        })

};

// export const OTPVerificationReducer = (builder: ActionReducerMapBuilder<UserState>) => {
//     builder
//         .addCase(userVerification.pending, (state) => {
//             state.loading = true;
//             state.isError = false;
//             state.error = {};
//             state.apiStatus = false;
//         })
//         .addCase(userVerification.fulfilled, (state, action) => {
//             state.loading = false;
//             state.loading = false;
//             console.log(action.payload.data);
//             if (action.payload.data.user_exists && action.payload.data.user) {
//                 state.user = action.payload.data.user;
//                 if (state.remeberMe) {

//                     localStorage.setItem("access_token", action.payload.data.access_token);
//                     localStorage.setItem("refresh_token", action.payload.data.refresh_token);
//                 }
//                 // console.log(action.payload.success);
//                 // state.apiStatus = action.payload.success;
//                 state.access_token = action.payload.data.access_token;
//                 state.isAuthenticated = true;
//                 state.refresh_token = action.payload.data.refresh_token;
//             } else {
//                 console.log("called")
//                 // state.apiStatus = true;
//                 state.temporary_token = action.payload.data.temp_token;
//                 state.isRegister = true;
//             }



//         })
//         .addCase(userVerification.rejected, (state, action) => {
//             state.loading = false;
//             state.isError = true;
//             state.error.message = "Something went wrong";
//         })

//         // RESEND OTP
//         .addCase(resendOTP.pending, (state) => {
//             state.loading = true;
//             state.isError = false;
//             state.error = {};
//         })
//         .addCase(resendOTP.fulfilled, (state) => {
//             state.loading = false;
//         })
//         .addCase(resendOTP.rejected, (state, action) => {
//             state.loading = false;
//             state.isError = true;
//             // state.error.message = action.payload?.message || "Something went wrong";
//         });
// };
